import React, { useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'


const IdleTimerComponent = ({
  onTimeout,
  onLogout,
  timeInSeconds,
}) => {
  const getTimeUntilLogoutAlert = () => process.env.REACT_APP_TIME_UNTIL_LOGOUT_ALERT || 840
  const getTimeUntilLogoutAfterAlert = () => process.env.REACT_APP_TIME_UNTIL_LOGOUT_AFTER_ALERT || 60

  const { getRemainingTime, getLastActiveTime, reset } = useIdleTimer({
    onIdle: () => onTimeout({ getRemainingTime, getLastActiveTime, reset }),
    onAction: () => {
      if ((new Date().getTime() - getLastActiveTime()) / 1000 >= parseInt(getTimeUntilLogoutAlert()) + parseInt(getTimeUntilLogoutAfterAlert())) {
        onLogout()
      }
      reset()
    },
    timeout: 1000 * parseInt(timeInSeconds, 10),
  })

  // No rendered output needed for hook usage
  return null
}

export default IdleTimerComponent
